import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsNgrokComponent } from './simple-icons-ngrok.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsNgrokComponent ],
    exports:      [ SimpleIconsNgrokComponent ],
    bootstrap:    []
})
export class SimpleIconsNgrokModule {}
